import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suspend-payment-processors',
  templateUrl: './suspend-payment-processors.component.html',
  styleUrls: ['./suspend-payment-processors.component.scss']
})
export class SuspendPaymentProcessorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
